export const COLUMN_MAPPING = {
  'comp_size': 'curr_comp_size',
  'curr_financial_info.est_revenue': 'curr_financial_info.revenue_norm.from',
  'products.product_competitors': 'products.product_competitors.name'
}